import PhoneInput from './PhoneInput'
import NumberInput from './NumberInput'
import PasswordInput from './PasswordInput'
import TextInput from './TextInput'
import SelectInput from './SelectInput'
import TextAreaInput from './TextAreaInput'
import EmailInput from './EmailInput'

import ProgressInput from './ProgressInput'
import ProfileImageInput from './ProfileImageInput'
import CheckboxInput from './CheckboxInput'
import PriceInput from './PriceInput'
import SliderInput from './SliderInput'
import AdvancedSelectInput from './AdvancedSelectInput'
import MultiSelectInput from "./MultiSelectInput"
import ImageInput from "./ImageInput"
import SubformInput from "./SubformInput"
import SwitchInput from './SwitchInput'
// import MapInput from './MapInput'
import SmartInput from './SmartInput'
import FilterEditor from './FilterEditor'
import IconManagerInput from './IconManagerInput'
import UsernameInput from './UsernameInput'
import DateInput from './DateInput'
import DateInputNew from './DateInputNew'
import ColorInput from './ColorInput'
import GlobalUserInput from './GlobalUserInput'
// import MapLeafletInput from './MapLeafletInput'
import IndoorLocationInput from './IndoorLocationInput'
import NewStatusIndicator from './NewStatusIndicator'
import StatusIndicator from './StatusIndicator'
import Calculator from './Calculator'
import FileInput from './FileInput'
import EditorInput from './EditorInput'
import AttributesLoader from './AttributesLoader'
import TableViewerInput from './TableViewerInput'
import MultiLevelInput from './MultiLevelInput'
import TagInput from './TagInput'
import SlidesInput from './SlidesInput'
import SubformWrapInput from './SubformWrapInput'
import ColorGradientInput from './ColorGradientInput'
import MultiTreeSelectAddListing from './MultiTreeSelectAddListing'
import AdvancedMultiTreeSelectAddListing from './AdvancedMultiTreeSelectAddListing'
import CaptchaInput from './CaptchaInput'
import GenerateCodeInput from './GenerateCodeInput'
import JalaliDateInput from './JalaliDateInput'
import ProfessionalStatusInput from './ProfessionalStatusInput'




const inputComponents = {
    PhoneInput,
    NumberInput,
    PasswordInput,
    TextInput,
    SelectInput,
    TextAreaInput,
    ProfileImageInput,
    CheckboxInput,
    EmailInput,
    PriceInput,
    SliderInput,
    AdvancedSelectInput,
    MultiSelectInput,
    ImageInput,
    SubformInput,
    SubformWrapInput,
    SwitchInput,
    // MapInput,
    SmartInput,
    FilterEditor,
    IconManagerInput,
    UsernameInput,
    DateInput,
    DateInputNew,
    ColorInput,
    GlobalUserInput,
    // MapLeafletInput,
    IndoorLocationInput,
    NewStatusIndicator,
    StatusIndicator,
    Calculator,
    FileInput,
    EditorInput,
    AttributesLoader,
    TableViewerInput,
    MultiLevelInput,
    TagInput,
    SlidesInput,
    ColorGradientInput,
    MultiTreeSelectAddListing,
    AdvancedMultiTreeSelectAddListing,
    ProgressInput,
    CaptchaInput,
    GenerateCodeInput,
    JalaliDateInput,
    ProfessionalStatusInput

}

export default (inputComponents);